module.exports = __webpack_public_path__ + "img/rank-1.23400e4e.svg";